import { ShowReport } from "components/reports/show";
import { viewContainer } from "helpers/redux";
import { REPORT_TYPES } from "helpers/reports";
import React from "react";
import SuitableOrdersReport from "./suitableOrdersReport";

class ConfiguredReport extends ShowReport {
    reportComponent = () => SuitableOrdersReport;
}

const ReportWrapper = (props) => (
    <div className="page-content">
        <ConfiguredReport {...props} id={REPORT_TYPES.SuitableOrdersReport} transition="full" />
    </div>
);

export default viewContainer(ReportWrapper, "reports");
